import { colors } from '@/theme/colors';

export default function SalesPitchCalculatorGradient() {
  return (
    <div style={{ filter: 'blur(32.5px)', position: 'absolute', bottom: 0, left: 0 }}>
      <svg
        width="476"
        height="366"
        viewBox="0 0 476 366"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M390.965 120.026L293.181 145.406L401.482 257.687L471.5 155L390.965 120.026Z"
          fill={colors.yellow63}
        />
        <path
          d="M312.571 139.251L346.562 167.99C359.523 178.949 346.538 199.479 331.082 192.464C328.27 191.188 325.126 190.835 322.1 191.456L286.323 198.804C250.312 206.199 214.054 187.309 199.48 153.558L197.921 149.948C196.644 146.992 195.039 144.19 193.134 141.594C177.236 119.922 184.997 89.1335 209.269 77.5882L242.961 61.5618C248.597 58.8808 254.711 57.3506 260.946 57.0607L339.884 53.3891C354.369 52.7154 362.164 70.1572 352 80.5L267 153.5L286.53 138.598C294.288 132.679 305.119 132.95 312.571 139.251Z"
          fill={colors.yellow63}
        />
        <path
          d="M472.308 128.436L470.069 123.114C457.543 93.3312 416.994 89.2751 398.816 115.987C388.213 131.568 368.309 137.845 350.685 131.166L330.693 123.589C327.902 122.531 325.199 121.254 322.609 119.769L305.854 110.16C271.587 90.5095 229.785 119.149 235.735 158.2C236.572 163.69 238.409 169.059 241.088 173.924C250.133 190.348 267.858 200.469 286.589 199.629L420.925 193.61C426.586 193.356 432.172 192.213 437.477 190.221L447.279 186.54C470.599 177.784 481.966 151.398 472.308 128.436Z"
          fill={colors.orange60}
        />
        <path
          d="M349.573 181.023L352.272 187.388C355.794 195.689 367.738 195.143 370.487 186.556C370.991 184.982 371.888 183.562 373.093 182.431L438.513 121.012C460.86 100.031 461.933 64.8942 440.908 42.5889C428.718 29.6568 411.065 23.3548 393.442 25.6429L322.097 34.9058C288.582 39.2572 274.499 80.0673 298.198 104.162L335.901 142.495C340.801 147.477 338.558 155.889 331.829 157.77C320.982 160.803 324.08 176.935 335.278 175.735L339.76 175.255C343.945 174.807 347.929 177.149 349.573 181.023Z"
          fill={colors.red57}
        />
        <path
          d="M336.512 38.643L338.387 68.4203C339.687 89.0804 366.974 95.536 377.395 77.6489C384.175 66.0101 400.019 63.7027 409.837 72.9242L415.034 77.8053C416.368 79.0579 417.574 80.4517 418.623 81.9506C434.249 104.273 469.379 95.0286 471.642 67.8744L473.365 47.2034C473.582 44.5972 473.516 41.949 473.174 39.3562C470.764 21.048 455.773 6.75351 437.352 5.45678L383.583 1.67158C376.19 1.15121 368.788 2.52694 362.076 5.66843L353.747 9.56704C342.573 14.797 335.737 26.3304 336.512 38.643Z"
          fill={colors.yellow63}
        />
      </svg>
    </div>
  );
}
